<template>
    <div class="d-flex justify-content-center align-items-center py-3">
        <input type="checkbox" refs="myButton" :value="feature.id" :id="feature.id" class="k-checkbox checkBoxcss" :checked="checkSelected" >
    </div>    
</template>

<script>
    export default{
        props: {   
            dataItem: Object,
            columnIndex: Number    
        },
        methods: {
            
        },
        data: function() {
            return {
                item: { ...this.dataItem },
                value: ""
            };
        },
                
        computed: {
            feature: function(){                                
                const fetureData = this.dataItem;
                return fetureData;              
            },
            checkSelected: function(){
                const seletedFeature = this.$store.state.packageModules.editModule.features;  
                var checkflag = false; 
                if(typeof(this.$route.params.modId) != 'undefined'){
                    checkflag = false;
                    if(seletedFeature && seletedFeature.length>0) {
                    for(var i = 0; i < seletedFeature.length; i++){                       
                        if(this.dataItem.id == seletedFeature[i].id){
                            checkflag = true; 
                        }                                                                                         
                    }
                    } else {
                        return checkflag;
                    }
                    return checkflag;                  
                }else{
                    return checkflag;
                }                
            }            
        }
    }
    
</script>
